import {
  GO_TO_PROJECT_STEP,
  RESET_PROJECT_FORM_DATA
} from '#action/types';

const defaultState = {
  step: 0
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GO_TO_PROJECT_STEP:
      return { ...state, step: action.payload };
    case RESET_PROJECT_FORM_DATA:
      return defaultState;
    default:
      return state;
  }
};
